import moment from 'moment';

const initialState = {
  company_details: {},
  start_date: moment(moment().subtract(30, 'days')).format('YYYY-MM-DD'),
  end_date: moment().format('YYYY-MM-DD'),
  entity_id: '',
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_REPORT_REDUCER': {
      return initialState;
    }
    case 'SET_COMPANY_DETAILS_REPORT_REDUCER': {
      return { ...state, company_details: action.data };
    }
    case 'SET_COMPANY_ENTITY_ID_REDUCER': {
      return { ...state, comapny_entity_id: action.data };
    }
    case 'SET_START_DATE_REPORT_REDUCER': {
      return { ...state, start_date: action.data };
    }
    case 'SET_END_DATE_REPORT_REDUCER': {
      return { ...state, end_date: action.data };
    }

    default:
      return state;
  }
};

export default reportReducer;
